import React, { useEffect } from 'react';

interface CardsResizerProps {
    anchorClasses?: string[] | null;
    triggers?: any[] | null;
    trigger1?: any | null;
    trigger2?: any | null;
    trigger3?: any | null;
}

const CardsResizer: React.FC<CardsResizerProps> = (props) => {
    const handleResize = () => {
        const classesToConsider = props.anchorClasses && props.anchorClasses.length > 0 ? props.anchorClasses : ['card-section info'];

        classesToConsider.forEach((cl) => {
            // set height to auto, allow browser to relayout
            Array.from(document.getElementsByClassName(cl) as HTMLCollectionOf<HTMLElement>).forEach((x) => {
                x.style.height = 'auto';
            });

            // get the highest element
            let maxHeight = 0;
            Array.from(document.getElementsByClassName(cl) as HTMLCollectionOf<HTMLElement>).forEach((x) => {
                const elementHeight = x.getBoundingClientRect().height;
                if (elementHeight > maxHeight) {
                    maxHeight = elementHeight;
                }
            });

            // define the height on all the elements
            if (maxHeight > 0) {
                Array.from(document.getElementsByClassName(cl) as HTMLCollectionOf<HTMLElement>).forEach((x) => {
                    x.style.height = maxHeight.toString() + 'px';
                });
            }
        });
    };

    useEffect(() => {
        const removeResizeEvent = () => { window.removeEventListener('resize', handleResize); };
        window.addEventListener('resize', handleResize);
        return removeResizeEvent;
    }, props.triggers ? props.triggers : [props.trigger1, props.trigger2, props.trigger3]);

    useEffect(() => {
        handleResize();
        setTimeout(handleResize, 50);
    }, props.triggers ? props.triggers : [props.trigger1, props.trigger2, props.trigger3]);

    return null;
};

export default CardsResizer;
